
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import { NavBar, SpeakingUtility, PlayAudioModal } from '@/components'
import store from '../store'
import FetchWrapper from '@/classes/fetchWrapper'

class SocketioService {
  socket
  io
  buefy
  printNewMessageReceived
  localStream
  devices
  activeVideoWebsocketId
  /* outputAudioEl
  outputAudioStream */

  constructor (io, buefy, printNewMessageReceived) {
    this.io = io
    this.buefy = buefy
    this.printNewMessageReceived = printNewMessageReceived
    this.init()
  }

  async terminateSocketConnection () {
    await this.socket.disconnect()
  }

  setupSocketConnection () {
    this.socket = this.io.connect(`${process.env.VUE_APP_SERVERURL}/chat`, {
      auth: {
        token: store.getters.getAccessToken
      },
      path: '/socket.io'
    })

    this.socket.on('message-sent', ({ content, ts, socket }) => {
      this.printNewMessageReceived(content, ts)
    })

    this.socket.on('no-credits-available', () => {
      this.buefy.dialog.confirm({
        title: 'Error',
        message: 'You do not have any more Chat Message credits.',
        onConfirm: async () => {
          await this.terminateSocketConnection()
          window.location.href = '/home/chats'
        },
        canCancel: false
      })
    })

    this.socket.on('unauthorized', async () => {
      this.buefy.dialog.confirm({
        title: 'Unauthorized',
        message: 'You are not allowed to join this chat.',
        onConfirm: async () => {
          await this.terminateSocketConnection()
          window.location.href = '/home/chats'
        },
        canCancel: false
      })
    })

    this.socket.on('connect_error', (err) => {
      this.buefy.dialog.confirm({
        title: 'Connection Error',
        message: err.message,
        canCancel: false
      })
    })

    this.socket.on('disconnect', (err) => {
      console.log(`socket disconnected = ${err.message}`)
    })
  }

  async init () {
    this.setupSocketConnection()
  }

  async joinChat (chatId) {
    this.socket.emit('join-chat', {
      chatId
    })
  }

  async leaveChat (chatId) {
    this.socket.emit('leave-chat', {
      chatId
    }, this.afterLeftChat.bind(this))
  }

  async sendMessage (chatId, content) {
    this.socket.emit('send-message', {
      chatId,
      content
    })
  }

  async requestBotAnswer (chatId) {
    this.socket.emit('request-bot-answer', {
      chatId
    })
  }

  async afterLeftChat () {
    await this.terminateSocketConnection()
  }
}

@Component({
  components: {
    NavBar,
    SpeakingUtility,
    PlayAudioModal
  }
})

export default class ChatsView extends Vue {
  data () {
    return {
      isLoading: false,
      isFirstLoad: true,
      chats: [],
      chatHistory: [],
      inputText: '',
      loggedUserId: null,
      socketioService: null,
      currChatId: null,
      currOtherUserId: null,
      currBotId: null,
      fireLogout: false,
      chatmessageCredits: 0,
      chatHistoryId: null,
      audioChatFilePath: '',
      sendingAudio: false,
      processAudio: false,
      closePlayAudioModal: false,
      playAudioFilePath: '',
      isFirstTimeUpdateUnreadChats: true,
      isMobileScreen: false,
      activeChatUserName: '',
      previousWindowInnerWidth: null
    }
  }

  mounted () {
    window.addEventListener('resize', this.updateWindowSize)
    this.updateWindowSize()
    this.getCurrUserId()
    this.initChats()
    this.getAcountCreditsInfo()
  }

  getCurrUserId () {
    this.loggedUserId = store.getters.getLoggedUserId
  }

  updateWindowSize () {
    if (!this.previousWindowInnerWidth || this.previousWindowInnerWidth > 700 || window.innerWidth > 700) {
      this.isMobileScreen = window.innerWidth <= 700
    }
    this.previousWindowInnerWidth = window.innerWidth
  }

  updateSideBar () {
    if (window.innerWidth <= 700) {
      this.isMobileScreen = !this.isMobileScreen
    }
  }

  showPointer () {
    if (window.innerWidth <= 700) {
      return 'cursor: pointer;'
    } else {
      return ''
    }
  }

  async initChats () {
    await this.getChats()
    try {
      this.socketioService = await this.loadSocketClientIoJs()
      if (this.chats[0].id) {
        await this.joinChat(this.chats[0].id, false, this.chats[0].name)
      }
    } catch (err) {
      console.warn(err)
    }
    this.isFirstLoad = false
    this.isLoading = false
  }

  async getAcountCreditsInfo () {
    this.isLoading = true || this.isFirstLoad
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/stats/getAcountCreditsInfo`))
      this.chatmessageCredits = resp.chatmessageCredits
      this.isLoading = false || this.isFirstLoad
      if (this.chatmessageCredits <= 0) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: 'You do not have any more Chat Message credits. Send button is blocked.',
          canCancel: true
        })
      }
    } catch (e) {
      this.isLoading = false || this.isFirstLoad
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get Credits Information.',
        canCancel: false
      })
    }
  }

  async getChats () {
    this.isLoading = true || this.isFirstLoad
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getChats`))
      resp.map(chat => {
        chat.selected = false
        if (chat.bots.length > 0) {
          chat.name = chat.bots[0].name
        } else {
          chat.name = chat.users.find(e => e.id !== this.loggedUserId).name
        }
        chat.isThereNewChatMessage = false
        return 0
      })
      this.chats = resp
      this.isLoading = false || this.isFirstLoad
    } catch (e) {
      this.isLoading = false || this.isFirstLoad
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get chats.',
        canCancel: false
      })
    }
  }

  async getChatHistory (chatId) {
    try {
      this.chats.map(chat => {
        if (chat.id === chatId) {
          chat.selected = true
          if (chat.bots.length > 0) {
            this.currBotId = chat.bots[0].id
          } else {
            var ls = chat.users.filter(e => e.id !== this.loggedUserId)
            if (ls.length === 0) {
              throw Error('Could not find other user id.')
            } else {
              this.currOtherUserId = ls[0].id
            }
          }
        } else {
          chat.selected = false
        }
        return 0
      })
    } catch (e) {
      this.isLoading = false || this.isFirstLoad
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get chats. ${e.message}`,
        canCancel: false
      })
    }
    this.isLoading = true || this.isFirstLoad
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getChatHistory/${chatId}`))
      resp = resp.filter(e => e.content)
      resp.map(e => { e.dateTime = new Date(e.dateTime); return 0 })
      resp.sort((a, b) => a.dateTime > b.dateTime ? 1 : -1)
      this.chatHistory = resp
      setTimeout(e => {
        this.scrollToLastHistory()
      }, 100)
      this.isLoading = false || this.isFirstLoad
    } catch (e) {
      this.isLoading = false || this.isFirstLoad
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get chats.',
        canCancel: false
      })
    }
  }

  async getAudioChatData (chatId) {
    this.isLoading = true || this.isFirstLoad
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getAudioChatData/${chatId}`))
      this.chatHistoryId = resp.chatHistoryId
      this.audioChatFilePath = resp.filePath == null ? '' : resp.filePath
      this.isLoading = false || this.isFirstLoad
    } catch (e) {
      this.isLoading = false || this.isFirstLoad
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get audio chat data.',
        canCancel: false
      })
    }
  }

  async setChatUserAsRead (chatId) {
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/setChatUserAsRead/${chatId}`))
      var idx = this.chats.findIndex(chat => chat.id === chatId)
      if (idx > -1) {
        this.chats[idx].isThereNewChatMessage = false
      }
    } catch (e) {
      console.error(e)
    }
  }

  sendText () {
    if (this.inputText && this.inputText !== '') {
      this.socketioService.sendMessage(this.currChatId, this.inputText)
      this.chatHistory.push({
        dateTime: new Date(),
        content: this.inputText,
        userId: this.loggedUserId
      })
      this.inputText = ''
      setTimeout(e => {
        this.scrollToLastHistory()
      }, 100)
    }
  }

  sendAudio () {
    this.processAudio = true
  }

  async audioProcessingFinished (resp) {
    this.processAudio = false
    await this.getAudioChatData(this.currChatId)
    this.chatHistory.push(resp.chatHistory)
    setTimeout(e => {
      this.scrollToLastHistory()
      this.socketioService.requestBotAnswer(this.currChatId)
    }, 100)
  }

  async openPlayAudioModal (chatHistoryId) {
    var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getChatHistoryAudioFilePath/${chatHistoryId}`))
    this.playAudioFilePath = resp.filePath
    this.closePlayAudioModal = true
  }

  async printNewMessageReceived (content, ts) {
    this.chatHistory.push({
      dateTime: new Date(ts),
      content: content,
      userId: this.currOtherUserId ? this.currOtherUserId : null
    })
    setTimeout(e => {
      this.scrollToLastHistory()
    }, 100)
  }

  async scrollToLastHistory () {
    if (this.$refs && this.$refs.chatHistory) {
      var item = this.$refs.chatHistory.lastElementChild
      if (item) {
        item.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }

  resetSpeakingUtilityCurrMilliseconds () {
    if (this.$refs && this.$refs.speakingUtility) {
      this.$refs.speakingUtility.resetCurrentTimeMillis()
    }
  }

  updateUnreadChats (unreadChats) {
    if (!this.isFirstTimeUpdateUnreadChats) {
      this.chats.map(chat => {
        if (unreadChats.findIndex(item => item.chatId === chat.id) > -1) {
          chat.isThereNewChatMessage = true
        } else {
          chat.isThereNewChatMessage = false
        }
        return 0
      })
    } else {
      this.isFirstTimeUpdateUnreadChats = false
      setTimeout(e => {
        this.updateUnreadChats(unreadChats)
      }, 1000)
    }
  }

  async loadSocketClientIoJs () {
    return new Promise((resolve, reject) => {
      const recaptchaScript = document.createElement('script')
      recaptchaScript.onload = () => {
        var socketioService = new SocketioService(window.io, this.$buefy, this.printNewMessageReceived)
        resolve(socketioService)
      }
      recaptchaScript.orerror = () => {
        reject(new Error('could not load socket.io lib.'))
      }
      recaptchaScript.setAttribute(
        'src',
        `${window.location.protocol}//${window.location.host}/scripts/socket.io.js`
      )
      document.head.appendChild(recaptchaScript)
    })
  }

  async joinChat (chatId, setRead, userName) {
    if (this.currChatId !== null && this.currChatId !== chatId) {
      await this.socketioService.leaveChat(this.currChatId)
    }
    this.activeChatUserName = userName
    this.currChatId = chatId
    await this.getChatHistory(chatId)
    await this.socketioService.joinChat(chatId)
    await this.getAudioChatData(chatId)
    if (setRead) {
      await this.setChatUserAsRead(chatId)
    }
    this.resetSpeakingUtilityCurrMilliseconds()
    this.updateSideBar()
  }

  async logoutRequested () {
    if (this.currChatId !== null) {
      await this.socketioService.leaveChat(this.currChatId)
    }
    this.fireLogout = true
  }
}
